import { render } from "./DatabaseVersion100.vue?vue&type=template&id=181971a4&scoped=true"
import script from "./DatabaseVersion100.vue?vue&type=script&lang=js"
export * from "./DatabaseVersion100.vue?vue&type=script&lang=js"

import "./DatabaseVersion100.vue?vue&type=style&index=0&id=181971a4&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-181971a4"]])

export default __exports__